import {
  FetchFinProductCategoriesFilters,
  FetchProductCategoriesCacheKey
} from '../../productsTypes';

import {
  FETCH_PRODUCT_COLORS_QUERY,
  FetchProductColorsQueryResponse
} from '../../queries/fetchProductColors.query';
import { FETCH_CACHE_PRODUCT_COLORS_QUERY } from '../../queries/fetchCacheProductColors.query';

import { useFinPaginatedCategories } from '../../../categories/hooks/useFinPaginatedCategories';

import { FetchCategoriesScopes } from '../../../categories/categoriesTypes';
import { CategoriesPermissions } from '../../../categories/categoriesConstants';

const defaultInitialFilters = {
  scope: { eq: FetchCategoriesScopes.FACILITY_COLORS }
};
const options = {
  staleTime: 1000 * 60 * 60
};

interface ProductColorsDefaultOptions {
  cacheKey: FetchProductCategoriesCacheKey;
  addInitialFilters?: FetchFinProductCategoriesFilters;
}

function useProductColors({
  cacheKey,
  addInitialFilters
}: ProductColorsDefaultOptions) {
  const initialFilters = addInitialFilters
    ? { ...defaultInitialFilters, ...addInitialFilters }
    : defaultInitialFilters;

  const {
    categories,
    categoriesError,
    categoriesFetched,
    categoriesIsPlaceholderData
  } = useFinPaginatedCategories<FetchProductColorsQueryResponse>({
    action: CategoriesPermissions.READ_PRODUCT_CATEGORIES_INDEX_ES_QUERY,
    cacheKey,
    query: FETCH_PRODUCT_COLORS_QUERY,
    cacheQuery: FETCH_CACHE_PRODUCT_COLORS_QUERY,
    initialFilters,
    options
  });

  return {
    productColors: categories,
    productColorsErrorMessage: categoriesError,
    productColorsFetched: categoriesFetched,
    productColorsIsPlaceholderData: categoriesIsPlaceholderData
  };
}

export default useProductColors;
